(ns guidebook.views.legacy-planning
  (:require
   [guidebook.common :as gc]
   [reagent.format :as fmt]
   [very.re-frame.core :as rf]
   [cljss.core :as cljss]
   [util.core :refer [valid-date?]]
   [css.vars :as vars]
   [css.core
    :refer [get-theme]
    :refer-macros [defstyled]]))

(defstyled header-row-s :div
  {:display "flex"
   :justify-content "space-between"
   :align-items "center"
   :border-bottom (str "1px solid " vars/border-light)
   :padding "0 1.25rem 1.25rem"
   :margin-bottom "2rem"})

(defstyled section-header-s :h2
  {:font-size "2.5rem"
   :font-weight "700"
   :margin-top "6rem"
   :padding-left "1.25rem"
   ::cljss/media {[:print]
                  {:-webkit-margin-before 0
                   :-webkit-margin-after 0
                   :margin-top "5rem"}}})

(defstyled legacy-planning-sheet-s :div
  {:min-height "100vh"
   :padding "135px 100px"
   :display "grid"
   :grid-template-columns "50%"
   :position "relative"
   ::cljss/media {[:print]
                  {:grid-template-columns "75%"
                   :padding "82px 100px 164px"}}})

(defstyled date-s :span
  {:font-weight "700"})

(defn estate-row [type value]
  (condp = type
    :estate-planning-attorney [gc/make-row {:label "Name"
                                            :value value}]
    :successor-trustee [gc/make-row {:label "Successor trustee"
                                     :value value}]
    :creation-date [gc/make-row {:label "Creation date"
                                 :value (gc/format-date value)}]
    :estate-plan-date [gc/make-row {:label "Documents submitted"
                                    :value (gc/format-date value)}]
    :estate-plan-docs-on-file [gc/make-row {:label "Disclosure on file"
                                            :value (if (true? value) "Yes" "No")}]
    :effective-tax-rate [gc/make-row {:label "Current tax rate"
                                      :value (str value "%")}]
    :date-of-most-recent-tax-return [gc/make-row {:label "Date of Most Recent Tax Return"
                                                  :value (gc/format-date value)}]
    :tax-returns-on-file [gc/make-row {:label "Documents submitted"
                                       :value (if (true? value) "Yes" "No")}]))

(defn insurance-policy-row [type value]
  (condp = type
    :carrier [gc/make-row {:label "Carrier"
                           :value value}]
    :amount [gc/make-row {:label "Policy amount"
                          :value (fmt/currency-format value)}]
    :premium-amount [gc/make-row {:label "Premium amount"
                                  :value (fmt/currency-format value)}]
    :premium-due-date [gc/make-row {:label "Premium due date"
                                    :value (gc/format-date value)}]
    :issue-date [gc/make-row {:label "Date of issue"
                              :value (gc/format-date value)}]
    :exp-date [gc/make-row {:label "Expiration date"
                            :value (gc/format-date value)}]
    :beneficiaries [gc/make-row {:label "Beneficiaries"
                                 :value (if (empty? value) "-" value)}]))

(defn estate-table []
  (fn [{:keys [estate-planning-attorney
               successor-trustee
               estate-plan-date
               estate-plan-docs-on-file
               effective-tax-rate
               date-of-most-recent-tax-return
               tax-returns-on-file]}]
    [gc/table-s {:margin-top "3rem"}
     [header-row-s
      [gc/header-s "Estate"]]
     [estate-row :estate-planning-attorney estate-planning-attorney]
     [estate-row :successor-trustee successor-trustee]
     [estate-row :estate-plan-date estate-plan-date]
     [estate-row :estate-plan-docs-on-file estate-plan-docs-on-file]
     [estate-row :effective-tax-rate effective-tax-rate]
     [estate-row :date-of-most-recent-tax-return date-of-most-recent-tax-return]
     [estate-row :tax-returns-on-file tax-returns-on-file]]))

(defn insurance-policy-table [{:keys [policy-type carrier amount premium-amount premium-due-date issue-date exp-date beneficiaries]}]
  [gc/table-s {:margin-top "3rem"}
   [header-row-s
    [gc/header-s policy-type]]
   [insurance-policy-row :carrier carrier]
   [insurance-policy-row :amount amount]
   [insurance-policy-row :premium-amount premium-amount]
   [insurance-policy-row :premium-due-date premium-due-date]
   [insurance-policy-row :issue-date issue-date]
   [insurance-policy-row :exp-date exp-date]
   [insurance-policy-row :beneficiaries beneficiaries]])

(defn insurance-policies-table [insurance-policies]
  (into [:div] (map insurance-policy-table insurance-policies)))

(defn main []
  (let [data (rf/subscribe [:guidebook/legacy-planning])
        last-updated (rf/subscribe [:guidebook/updated-at])]
    (fn []
      (let [insurance-policies (:insurance-policies @data)]
        [legacy-planning-sheet-s
         [gc/title-s {:max-width "450px"} "Legacy Planning"]
         (when (valid-date? @last-updated)
           [gc/updated-s (str "Last updated on " (gc/format-date @last-updated))])
         [gc/body-s "Is your estate plan and insurance policy up-to-date? Has a significant event occurred since they were put in place? Does your family know who to call and where your important documents are located? Review the information below to ensure your legacy is carried out according to your plan."]
         [section-header-s "Estate Planning"]
         [estate-table @data]
         [section-header-s "Insurance"]
         [insurance-policies-table insurance-policies]]))))
